export enum CSV_EXPORT_TYPE {
  TEAM_MEMBER = 'team-member',
  RESIDENT = 'resident',
  LOGS = 'log',
  RISK_ASSESSMENT = 'risk-assessment',
  CARE_PLAN = 'care-plan',
  EMAR = 'emar',
  BULK = 'bulk',
  INCIDENT_REPORTS = 'incident-reports',
  ROSTERING_HISTORY = 'rostering-history',
  UPCOMING_ROTA = 'upcoming-rota',
  OUTCOME_AND_GOALS = 'goals'
}
